import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// Components
import { Textarea, Toggle } from 'components/Controls';
import ResultsFormSocialShare from './ResultsFormSocialShare';
import MultiLanguageTextField from 'components/MultiLanguageTextField';
import ResultsFormTheme from './ResultsFormTheme';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { isRequired } from 'utilities/validation';

const ResultsForm:FC = () => {
  const { t } = useTranslation();

  const { control, watch, formState: { errors } } = useFormContext();

  const quizType = watch('type');
  const resultsPageEnabled = watch("resultsPage.enabled");

  return (
    <div className="w-full">
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <span className="block text-white text-base font-semibold mr-3">{t('labels.showScreen')}</span>
          <Controller
            control={control} name="resultsPage.enabled"
            render={({ field: { onChange, value } }) => (
              <Toggle
                id="resultsPageEnabled"
                checked={value}
                onChange={onChange}
              />
            )}
          />
        </div>
        {!resultsPageEnabled ? (
          <Controller
            control={control} name="resultsPage.disabledPageText"
            rules={{ required: isRequired }}
            render={({ field }) => (
              <Textarea
                {...field}
                id="resultsPageDisabledText"
                required={true}
                error={!!errors.resultsPage?.disabledPageText}
                helperText={errors.resultsPage?.disabledPageText?.message}
              />
            )}
          />
        ) : null}
      </div>
      <ResultsFormTheme quizType={quizType} />
      <h2 className="text-xl font-bold text-white mb-4">{t('pages.quizForm.socialSharingLabel')}</h2>
      <MultiLanguageTextField
        name="brand"
        label={t('pages.quizForm.brandNameLabel')}
        helperText={t('pages.quizForm.brandNameHint')}
        className="mb-4"
      />
      <ResultsFormSocialShare />
    </div>
  )
}

export default ResultsForm;
